import { Hidden, useMediaQuery, useTheme } from "@material-ui/core";
import React, { useEffect, useReducer } from "react";
import { useDispatch } from "react-redux";
import { useHistory, withRouter } from "react-router-dom";
import { useStore } from "../../hooks/useStore";
import NavBar from "../../layout/NavBar/NavBar";
import { configPathname } from "../../redux/actions/configActions";
import { tabSelect } from "../../redux/actions/tabActions";
import { RoutePaths } from "../../utils/Items";
import { DrawerDesktop } from "../DrawerDesktop/DrawerDesktop";
import { DrawerMobile } from "../DrawerMobile/DrawerMobile";

export type State = {
  open: boolean;
  onDrawer: boolean;
  onNavbar: boolean;
};

export enum Type {
  OPEN = "open",
  CLOSE = "close",
  ON_DRAWER = "onDrawer",
  ON_NAVBAR = "onNavbar",
  LEAVE_DRAWER = "leaveDrawer",
  LEAVE_NAVBAR = "leaveNavbar",
}

type Action = {
  type: Type;
};

const initialState: State = {
  open: false,
  onDrawer: false,
  onNavbar: false,
};

const reducer = (state: State, action: Action): State => {
  switch (action.type) {
    case Type.OPEN:
      return { ...state, open: true };
    case Type.CLOSE:
      return { ...state, open: false };
    case Type.ON_DRAWER:
      return { ...state, onDrawer: true };
    case Type.ON_NAVBAR:
      return { ...state, onNavbar: true };
    case Type.LEAVE_DRAWER:
      return { ...state, onDrawer: false };
    case Type.LEAVE_NAVBAR:
      return { ...state, onNavbar: false };
    default:
      return state;
  }
};

const DrawerMain = ({ location }: any) => {
  const [state, originDispatch] = useReducer(reducer, initialState);
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down("sm"));
  const globalDispatch = useDispatch();
  const { tabStore } = useStore();
  const history = useHistory();

  const dispatch = (type: Type) => {
    originDispatch({ type });
  };

  useEffect(() => {
    if (!mobile && state.open && !state.onDrawer && !state.onNavbar)
      dispatch(Type.CLOSE);
  }, [state.onDrawer, state.onNavbar]);

  useEffect(() => {
    globalDispatch(configPathname(location.pathname));
    if (
      tabStore.tabSelectIndex === "-1" &&
      location.pathname === RoutePaths.EntryEvent
    )
      history.push(RoutePaths.SearchManualInput);
    if (
      location.pathname !== RoutePaths.EntryEvent &&
      tabStore.tabSelectIndex !== "-1"
    )
      globalDispatch(tabSelect("-1"));
  }, [location]);

  return (
    <div>
      <NavBar menuState={state} menuAction={dispatch} />
      <Hidden smDown>
        <DrawerDesktop menuState={state} menuAction={dispatch} />
      </Hidden>
      <Hidden mdUp>
        <DrawerMobile menuState={state} menuAction={dispatch} />
      </Hidden>
    </div>
  );
};

export default withRouter(DrawerMain);
